<template id="imageicon">
  <img :src="imgsrc" alt="">
</template>

<script>

import utils from './Utils.vue'
import Vue from 'vue'

export default {
  name: 'imageicon',
  props:['src', 'noimg'],
  data () {
    return {
      "imgsrc":null
    }
  },
  created: function() {
    var img = new Image();
    var self = this;
    img.onerror = function(evt) {
      //console.log(evt);
      self.imgsrc = self.noimg;
      self.$forceUpdate();
    };
    img.onload = function(evt) {
      //console.log(evt);
      self.imgsrc = this.src;
      self.$forceUpdate();
    };
    img.src = self.src;
  },
  components: {
  }
}

</script>


// WEBPACK FOOTER //
// src/components/ImageIcon.vue